<template>
  <b-form @submit.prevent="onSubmit" enctype="multipart/form-data">
    <b-form-group
      id="input-group-title"
      label="File Name"
      label-for="file-name"
      class="font-weight-bold pr-2"
    >
      <b-form-input
        id="file-name"
        type="text"
        required
        :value="file.name"
        v-model="form.name"
        aria-describedby="file-name-feedback"
      ></b-form-input>

      <b-form-invalid-feedback
        id="input-title-feedback"
      ></b-form-invalid-feedback>
    </b-form-group>
    <b-container fluid>
      <b-row>
        <b-col
          v-for="selected in fields"
          :key="selected.id"
          :cols="
            (selected.field_type === 'string' &&
              selected.label !== 'State of Issue' &&
              selected.field_type !== 'country') ||
            !hasSwitch
              ? '12'
              : '6'
          "
          class="pr-2 mb-0"
        >
          <b-form-group
            v-if="selected.field_type === 'string'"
            :id="selected.label"
            :label="selected.label"
            class="font-weight-bold"
          >
            <b-form-input
              :id="selected.label"
              :value="selected.value"
              type="text"
              required
              @change="addInformation($event, selected.id)"
            ></b-form-input>

            <b-form-invalid-feedback id="input-title-feedback">
              <!-- eslint-disable-next-line -->
        <!-- {{ errors.title }} -->
            </b-form-invalid-feedback>
          </b-form-group>
          <div v-if="selected.field_type === 'date'" class="mb-3">
            <label class="font-weight-bold">{{ selected.label }}</label>
            <b-form-input
              id="input-date"
              type="text"
              required
              placeholder="DD/MM/YYYY"
              aria-describedby="input-date-feedback"
              maxlength="10"
              :value="valueDate(selected.value)"
              :formatter="formatDate"
              @input="onSelectedDate($event, selected)"
              @change="inputDate(selected)"
            />
            <div class="invalid-feedback d-block">
              {{ errors.date.field === selected.id ? errors.date.message : '' }}
            </div>
            <b-form-group
              v-if="
                hasSwitch && hasSwitch.base_information_type_id === selected.id
              "
              class="pt-2"
            >
              <b-form-checkbox
                switch
                size="lg"
                v-model="calculate"
                @change="calculateExpiryDate()"
                ><label class="font-weight-bold pl-3 custom-label">
                  Automatically calculate {{ calculateYears }} years from expiry
                  date
                </label></b-form-checkbox
              >
            </b-form-group>
          </div>
          <div v-if="selected.field_type === 'country'" class="mb-3">
            <label for="country" class="font-weight-bold">{{
              selected.label
            }}</label>
            <b-form-select
              required
              :id="selected.label"
              :value="selected.value"
              value-field="name"
              text-field="name"
              :options="countries"
              @change="addInformation($event, selected.id)"
            ></b-form-select>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="pr-2 pl-0">
      <div class="page-subtitle mt-5 mb-4">File Upload</div>
      <div
        class="upload-container dashed mb-4 upload-border"
        v-cloak
        @drop.prevent="loadPhotos($event)"
        @dragover.prevent
      >
        <b-img
          :src="require('@/assets/icons/upload.svg')"
          alt="Photos"
          class="mt-4"
          v-bind="mainProps"
        ></b-img>

        <div class="upload-label mt-3 mb-3">
          <b-button variant="primary" @click="launchFilePicker"
            >Upload from device</b-button
          >
        </div>

        <b-form-file
          ref="filePicker"
          multiple
          accept="image/*, .pdf"
          style="display:none"
          @input="loadPhotos($event)"
          :state="state.files"
          aria-invalid="input-files-feedback"
        ></b-form-file>

        <label variant="secondary">Or drag them in</label>
      </div>

      <div class="preview-container" v-if="previews.length !== 0">
        <div
          class="preview-item"
          :class="pIndex !== previews.length - 1 ? 'mr-3' : ''"
          v-for="(preview, pIndex) in previews"
          :key="pIndex"
        >
          <b-icon-x-circle-fill
            variant="dark"
            class="remove-icon"
            @click="onRemovePreview(pIndex)"
          ></b-icon-x-circle-fill>

          <b-img-lazy
            :src="
              preview === 'pdf'
                ? require('@/assets/icons/adobe-acrobat.svg')
                : preview
            "
            alt="Photos"
            v-bind="previewProps"
            class="h-100"
          ></b-img-lazy>
        </div>
      </div>

      <div class="p-2 input-files-feedback" v-show="state.files === false">
        {{ errors.files }}
      </div>

      <b-row class="mt-5">
        <b-col>
          <b-button
            block
            class="btn-outlined bg-white text-dark"
            variant="outline-secondary"
            @click="discardForm()"
            >Discard</b-button
          >
        </b-col>
        <b-col>
          <b-button
            block
            type="submit"
            variant="primary"
            :disabled="loading || errors.date.field"
          >
            <b-spinner small v-if="loading"></b-spinner>
            <div v-else>{{ isRequestFileCreation ? 'Submit' : 'Next' }}</div>
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      :class="{
        'bg-danger border-danger': alertType === 'danger'
      }"
      dismissible
      fade
      :variant="alertType"
      @dismiss-count-down="countDownChanged"
    >
      {{ alertMsg }}
    </b-alert>
  </b-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { findIndex, isEqual, find } from 'lodash'
import Compressor from 'compressorjs'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      loading: false,
      mainProps: {
        center: true,
        width: 80
      },
      previewProps: {
        center: true,
        blank: true,
        blankColor: '#bbb'
      },
      previews: [],
      form: {
        id: null,
        name: this.file.name,
        files: [],
        information_types: []
      },
      deletedFiles: [],
      format: 'dd/MM/yy',
      uploadType: 'Multiple Files',
      selectedDate: null,
      addedDate: null,
      calculate: false,
      state: {
        files: null
      },
      errors: {
        files: null,
        date: {
          field: null,
          message: 'Please input a valid date'
        }
      },
      dismissCountDown: 0,
      alertMsg: '',
      alertType: 'primary'
    }
  },

  props: {
    file: {
      type: Object,
      required: true
    },
    template: {
      type: Number,
      default: null
    },
    selectedFields: {
      type: Array,
      default: null
    },
    new: {
      type: Boolean,
      default: true
    },
    hasSwitch: {
      type: Object,
      default: null
    },
    isRequestFileCreation: {
      type: Boolean,
      default: false
    },
    request: {
      type: Object,
      default: null
    }
  },

  computed: {
    ...mapState({
      countries: state => state.country.countries
    }),
    fields() {
      if (this.selectedFields === null) {
        return this.file.file_information_types
      } else return this.selectedFields
    },

    limitUpload() {
      return (
        (this.uploadType === 'Single File' && this.form.files.length === 1) ||
        (this.uploadType === 'Multiple Files' && this.form.files.length === 2)
      )
    },

    isVisaOrPassport() {
      return this.file.name === 'Visa' || this.file.name === 'Passport'
    },

    calculateYears() {
      return this.hasSwitch.no_of_years
    }
  },

  watch: {
    'form.files'(files) {
      this.state.files = true
    },

    request(newVal, oldVal) {
      if (
        this.isRequestFileCreation &&
        newVal &&
        this.$route.name === 'request.request-file-new-page'
      ) {
        this.form.name = newVal.name
        this.form.information_types = newVal.information_types.map(
          infoType => infoType.id
        )
      }
    }
  },

  methods: {
    ...mapActions({
      getCountries: 'country/getCountries',
      fileRequestShare: 'requests/fileRequestShare'
    }),
    discardForm() {
      if (this.isRequestFileCreation) {
        if (this.new) {
          this.$emit('back')
        } else {
          this.$router.replace({
            name: 'request.request-file-templates-page',
            params: {
              fileRequestUserId: this.$route.params.fileRequestUserId
            }
          })
        }
      } else {
        if (this.new) {
          this.$emit('back')
        } else {
          this.$router.replace({
            name: 'file.view-page',
            params: {
              id: this.$route.params.id
            }
          })
        }
      }
    },

    addInformation(event, id) {
      if (this.new) {
        if (find(this.form.information_types, { information_type_id: id })) {
          this.form.information_types.splice(
            findIndex(this.form.information_types, {
              information_type_id: id
            }),
            1
          )
        }
        this.form.information_types.push({
          information_type_id: id,
          value: event
        })
      } else {
        this.updateInformation(event, id)
      }
    },

    updateInformation(event, id) {
      const updateIndex = findIndex(this.form.information_types, {
        id: id
      })
      this.form.information_types[updateIndex].value = event
    },

    launchFilePicker() {
      this.$refs.filePicker.$el.childNodes[0].click()
    },

    loadPhotos(e) {
      // create form
      let _this = this
      const photos = e.dataTransfer ? e.dataTransfer.files : e

      this.loading = true // disable submit if still uploading

      for (let i = 0; i < photos.length; i++) {
        const file = photos[i]
        const reader = new FileReader()
        if (file && file.type === 'application/pdf') {
          this.previews.push('pdf')
          this.form.files.push(photos[i])
          this.loading = false
        } else {
          reader.readAsDataURL(photos[i])
          reader.onload = e => {
            const base64Img = e.target.result
            this.previews.push(base64Img)

            if (file.size > 2000000) {
              const binaryImg = this.convertDataURIToBinary(base64Img)
              const blob = new Blob([binaryImg], { type: file.type })

              // eslint-disable-next-line
            new Compressor(blob, {
                quality: 0.2,
                success(result) {
                  _this.addCompressedImage(result)
                }
              })
            } else {
              this.addCompressedImage(file)
            }
          }
        }
      }
    },

    addCompressedImage(result) {
      this.form.files.push(result)
      this.loading = false
    },

    convertDataURIToBinary(dataURI) {
      const BASE64_MARKER = ';base64,'
      const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length
      const base64 = dataURI.substring(base64Index)
      const raw = window.atob(base64)
      const rawLength = raw.length
      var array = new Uint8Array(new ArrayBuffer(rawLength))

      for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i)
      }
      return array
    },

    async uploadFile(photo, isLast) {
      // update form
      let data = new FormData()
      data.append('file', photo)
      await this.$api.post('media', data).then(({ data }) => {
        this.form.files.push(photo)
        this.previews.push(data.data.url)
      })

      if (isLast) {
        // enable submit if done uploading
        this.loading = false
      }
    },

    onRemovePreview(index) {
      if (this.new) {
        // create form
        this.form.files.splice(index, 1)
      } else {
        // update form
        const isDelete = this.form.files[index].delete
        this.deletedFiles.push(this.form.files[index].id)

        if (isDelete === false) {
          // set existing photo's delete field to true
          this.form.files[index].delete = true
        } else if (isDelete === true) {
          // find the new index of photo to be deleted and set it to true
          const falseIndex = findIndex(this.form.files, { delete: false })
          this.form.files[falseIndex + index].delete = true
        }
      }
      this.previews.splice(index, 1)
    },

    onSelectedDate(date, selected) {
      if (date.length === 10) {
        this.errors.date.field = null
        this.selectedDate = this.convertToISO(date)
      } else {
        this.errors.date.field = selected.id
      }
    },

    valueDate(date) {
      return this.new ? date : this.parseDate(date)
    },

    inputDate(selected) {
      if (this.new) {
        this.addInformation(this.selectedDate, selected.id)
      } else {
        this.updateInformation(this.selectedDate, selected.id)
      }
      if (this.calculate) {
        this.calculateExpiryDate()
      }
    },

    getFormData() {
      let formData = new FormData()
      formData.append('name', this.form.name)
      if (this.isRequestFileCreation && !this.request.template) {
        formData.append('template', this.template || '')
      }

      for (let i = 0; i < this.deletedFiles.length; i++) {
        formData.append('files[delete][' + i + ']', this.deletedFiles[i])
      }

      for (let i = 0; i < this.form.information_types.length; i++) {
        let information = this.form.information_types[i]
        formData.append(
          'information_types[' + i + '][information_type_id]',
          information.information_type_id
        )
        formData.append(
          'information_types[' + i + '][value]',
          information.value
        )
      }

      return formData
    },

    async onSubmit() {
      this.loading = true

      // if (this.uploadType === 'Multiple Files' && this.form.files.length < 2) {
      //   this.state.files = false
      //   this.errors.files = 'Please upload both sides of your card.'
      // } else if (
      //   this.uploadType === 'Single File' &&
      //   this.form.files.length === 0
      // )
      if (this.form.files.length === 0) {
        this.state.files = false
        this.errors.files = 'Please upload your card.'
      } else {
        if (!this.new) {
          // update form
          await this.$api
            .post(`file/${this.form.id}`, this.getFormData())
            .then(({ data }) => {
              if (data.success) {
                this.uploadFiles(data.data.id)
              }
            })
        } else {
          // create form
          await this.$api.post('file', this.getFormData()).then(({ data }) => {
            if (data.success) {
              this.uploadFiles(data.data.id)
            }
          })
        }
      }
    },

    getFileData() {
      let formData = new FormData()
      for (let i = 0; i < this.form.files.length; i++) {
        formData.append('files[]', this.form.files[i])
      }
      return formData
    },

    async uploadFiles(file) {
      if (!isEqual(this.file.files, this.form.files)) {
        await this.$api
          .post(`upload-file/${file}`, this.getFileData())
          .then(({ data }) => {
            if (data.success) {
              this.successUpload(file)
            }
          })
      } else this.successUpload(file)
      this.loading = false
    },

    async successUpload(file) {
      if (this.isRequestFileCreation) {
        let formData = {
          file: file,
          fileRequestId: this.request.id
        }

        await this.fileRequestShare(formData)
          .then(res => {
            this.$router.replace({
              name: 'file.success-page',
              params: {
                id: file
              }
            })
          })
          .catch(error => {
            if (error.status === 402) {
              this.$api.delete(`file/${file}`).then(({ data }) => {
                if (data.success) {
                  this.alertType = 'danger'
                  this.dismissCountDown = 15
                  this.alertMsg = error.data.message
                }
              })
            }
          })
      } else {
        if (this.new) {
          this.$router.replace({
            name: 'file.success-page',
            params: {
              id: file
            }
          })
        } else {
          this.$router.replace({
            name: 'file.view-page',
            params: {
              id: file
            }
          })
        }
      }
    },

    resetForm() {
      if (!this.new) {
        // update form
        for (let key in this.form) {
          this.form[key] = this.file[key]
          this.form.id = this.file.id
          this.previews = this.file.files.map(p => p.thumb_url)
          this.form.information_types = this.file.file_information_types.map(
            info => ({
              ...info,
              information_type_id: info.information_type_id
            })
          )
          this.form.files = this.file.files
        }
      }
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    },

    calculateExpiryDate() {
      const fromIndex = findIndex(this.form.information_types, {
        information_type_id: this.hasSwitch.base_information_type_id
      })
      const toIndex = findIndex(this.form.information_types, {
        information_type_id: this.hasSwitch.target_information_type_id
      })
      const index = findIndex(this.fields, {
        id: this.hasSwitch.target_information_type_id
      })
      if (fromIndex >= 0) {
        const addedDate = dayjs(this.selectedDate).add(
          this.calculateYears,
          'year'
        )
        this.addedDate = new Date(addedDate)

        this.fields[index].value = this.parseDate(this.addedDate)
        if (toIndex >= 0) {
          this.form.information_types[toIndex].value = new Date(
            addedDate
          ).toISOString()
        } else {
          this.form.information_types.push({
            information_type_id: this.hasSwitch.target_information_type_id,
            value: new Date(addedDate).toISOString()
          })
        }
      }
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    }
  },

  async mounted() {
    await this.getCountries()
    this.form.name = this.file.name
  },

  created() {
    this.resetForm()

    // if (this.new) {
    //   // create form
    //   this.uploadType =
    //     this.file.uploadType === 'single' ? 'Single File' : 'Multiple Files'
    // } else {
    //   // update form
    //   this.uploadType =
    //     this.file.files.length > 1 ? 'Multiple Files' : 'Single File'
    // }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  height: 56px;
}
.remove-icon {
  position: absolute;
  right: 6px;
  top: 6px;
  cursor: pointer;
}
.preview-item {
  width: 180px;
  height: 180px;
}
.upload-border {
  width: 100%;
  max-width: inherit;
}
.input-files-feedback {
  background: #ffe2e2 0% 0% no-repeat padding-box;
  color: red;
  text-align: center;
}
.custom-label {
  min-width: 100vw;
  font-size: 1rem;

  @media (max-width: 767px) {
    min-width: 75vw;
  }
}
</style>
